import React from "react";
import NavPart from "../NavPart";
import "../../styles/_homePage.scss";
import Home from "./Home";
import About from "./About";
import Projects from "./Projects";
import Contact from "./Contact";
import Footer from "../Footer";
import Skills from "./Skills";
import GitHub from "./GiHub";
import Publications from "./Publication";

const HomePage = ({ countData }) => {
  return (
    <div>
      <NavPart />
      <Home countData={countData} />
      {/* <Home /> */}
      <About />
      <Skills />
      <Projects />
      {/* <GitHub /> */}
      <Publications />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;

// during build, if issue
// CI=false npm run build
